import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";

// action types

export const GET_PAGES = "getPages";
export const GET_PAGE = "getPage";
export const UPDATE_PAGE = "updatePage";

// mutation types
export const SET_PAGES_ERROR = "setErrors";
export const SET_PAGES = "setPages";
export const SET_PAGE = "setPage";
export const SET_PAGE_LOAD = "setPageLoad";


const state = {
    errors: {},
    pages: {},
    load: true,
    page: {},
};

const getters = {
    gettersPages(state) {
        return state.pages;
    },
    gettersPage(state) {
        return state.page;
    },
    errorsPage(state){
        return state.errors;
    },
    getPageLoad(state){
        return state.load;
    }
};

const actions = {

    [GET_PAGES](context) {
        return new Promise((resolve, reject) => {
            context.commit(SET_PAGE_LOAD, true);
            ApiService.get("/pages")
                .then(({ data }) => {
                    context.commit(SET_PAGES, data.pages);
                    context.commit(SET_PAGE_LOAD, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_PAGES_ERROR, response.data.errors);
                    context.commit(SET_PAGE_LOAD, false);
                    reject(response);
                });
        });
    },

    [GET_PAGE](context, id) {
        context.commit(SET_PAGES_ERROR, {});
        context.commit(SET_PAGE_LOAD, true);
            ApiService.get("/edit/page", id)
                .then(({ data }) => {
                    context.commit(SET_PAGE, data.page);
                    context.commit(SET_PAGE_LOAD, false);
                })
                .catch(({ response }) => {
                    context.commit(SET_PAGES_ERROR, response.data.errors);
                    context.commit(SET_PAGE_LOAD, false);
                });
    },


    [UPDATE_PAGE](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/update/page", data.id, data.page)
                    .then(({ data }) => {
                        context.commit(SET_PAGES_ERROR, {});
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        if (response.status === 422){
                            context.commit(SET_PAGES_ERROR, response.data.errors);
                        }
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

};

const mutations = {
    [SET_PAGES_ERROR](state, error) {
        state.errors = error;
    },

    [SET_PAGES](state, pages) {
        state.pages = pages;
    },

    [SET_PAGE](state, pages) {
        state.page = pages;
    },

    [SET_PAGE_LOAD](state, load) {
        state.load = load;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};
